/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kind: NonNullable<unknown> }} Settings_Templates_New_LabelInputs */



/**
* | output |
* | --- |
* | "New conversation type: {kind}" |
*
* @param {Settings_Templates_New_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_new_label = /** @type {((inputs: Settings_Templates_New_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_New_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Nieuw gesprekstype: ${i?.kind}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Nouveau modèle : ${i?.kind}`)
	return /** @type {LocalizedString} */ (`New conversation type: ${i?.kind}`)
});